import React from 'react';

type Shape =
  | { d: string; w?: number; dash?: string }
  | { c: [number, number, number] }
  | { r: [number, number, number, number, number] }
  | { dot: [number, number] };

const SYMBOLS: Record<string, Shape[]> = {
  'i-search': [{ c: [11, 11, 7] }, { d: 'm20 20-3.5-3.5' }],
  'i-pin': [{ d: 'M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z' }, { c: [12, 10, 2.6] }],
  'i-cal': [{ r: [3.5, 5, 17, 15.5, 3] }, { d: 'M3.5 10h17M8 3v4M16 3v4' }],
  'i-clock': [{ c: [12, 12, 8.5] }, { d: 'M12 7.5V12l3 2' }],
  'i-arrow': [{ d: 'M5 12h14M13 6l6 6-6 6' }],
  'i-ticket': [
    { d: 'M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z' },
    { d: 'M14 6v12', dash: '2 2.5' },
  ],
  'i-check': [{ d: 'm5 12.5 4.5 4.5L19 7.5', w: 2.2 }],
  'i-alert': [{ d: 'M12 3 2.5 20h19z' }, { d: 'M12 10v4.5M12 17.2v.3' }],
  'i-refresh': [{ d: 'M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6' }],
  'i-hand': [
    {
      d: 'm11 17 2 2a1.5 1.5 0 0 0 2.1-2.1M13 15l2.5 2.5a1.5 1.5 0 0 0 2.1-2.1l-3.9-3.9-1.8 1.2a2 2 0 0 1-2.4-3.2L12.5 7 15 6l6 5M3 11l5-5 3 1M3 11l6 6',
    },
  ],
  'i-mega': [{ d: 'M3 10v4h4l6 4V6L7 10zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12' }],
  'i-star': [{ d: 'm12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z' }],
  'i-building': [{ d: 'M4 21V5l8-2v18M12 8h8v13M8 8v.01M8 12v.01M8 16v.01M16 12v.01M16 16v.01M2 21h20' }],
  'i-mail': [{ r: [3, 5, 18, 14, 3] }, { d: 'm4 7 8 6 8-6' }],
  'i-shield': [{ d: 'M12 3 4.5 6v6c0 4.6 3.2 8 7.5 9 4.3-1 7.5-4.4 7.5-9V6z' }, { d: 'm9 12 2 2 4-4' }],
  'i-bolt': [{ d: 'M13 2 4 14h7l-1 8 9-12h-7z' }],
  'i-compass': [{ c: [12, 12, 9] }, { d: 'm15.5 8.5-2 5-5 2 2-5z' }],
  'i-receipt': [{ d: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6' }],
  'i-users': [{ c: [9, 8, 3.5] }, { d: 'M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M18 14a6 6 0 0 1 3.5 6' }],
  'i-music': [{ d: 'M9 18V5l11-2v13' }, { c: [6.5, 18, 2.8] }, { c: [17.5, 16, 2.8] }],
  'i-tent': [{ d: 'M12 3 2 20h20zM12 3v17M8.5 20 12 13l3.5 7' }],
  'i-mask': [{ d: 'M4 5c5 2 11 2 16 0v6a8 8 0 0 1-16 0z' }, { d: 'M8 10.5h2M14 10.5h2M9 15c1.8 1.3 4.2 1.3 6 0' }],
  'i-mic': [{ r: [9, 3, 6, 11, 3] }, { d: 'M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21' }],
  'i-moon': [{ d: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z' }],
  'i-food': [{ d: 'M7 3v8M4.5 3v5a2.5 2.5 0 0 0 5 0V3M7 11v10M17 21V3c-2.5 1-4 3.5-4 7v3h4' }],
  'i-tool': [{ d: 'M14.5 5.5a4 4 0 0 0 5 5L12 18l-3-3zM9 15l-4.5 4.5M3 21l1.5-1.5' }],
  'i-palette': [
    { d: 'M12 3a9 9 0 1 0 0 18c1.2 0 1.8-.9 1.5-2-.4-1.4.4-2.5 1.8-2.5H18a3 3 0 0 0 3-3A9.2 9.2 0 0 0 12 3z' },
    { dot: [7.5, 11] },
    { dot: [11, 7.5] },
    { dot: [15.5, 8.5] },
  ],
  'i-menu': [{ d: 'M4 7h16M4 12h16M4 17h16' }],
  'i-x': [{ d: 'M6 6l12 12M18 6 6 18' }],
  'i-bag': [{ d: 'M5 8h14l-1 12H6z' }, { d: 'M9 8V6.5a3 3 0 0 1 6 0V8' }],
  'i-chevron': [{ d: 'm6 9 6 6 6-6' }],
  'i-ig': [{ r: [3.5, 3.5, 17, 17, 5] }, { c: [12, 12, 4] }, { dot: [17, 7] }],
  'i-li': [{ r: [3.5, 3.5, 17, 17, 3] }, { d: 'M8 10.5V16M8 7.6v.2M11.5 16v-5.5M11.5 13c0-1.6 1-2.6 2.4-2.6s2.1.9 2.1 2.6V16' }],
  'i-trophy': [{ d: 'M7 4h10v5a5 5 0 0 1-10 0zM7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M12 14v4M8 21h8M9 18h6' }],
  'i-share': [
    { d: 'M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z' },
  ],
  'i-link': [{ d: 'M9 17H7a5 5 0 1 1 0-10h2M15 7h2a5 5 0 1 1 0 10h-2M8 12h8' }],
  'i-chat': [{ d: 'M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z' }],
  'i-home': [{ d: 'M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z' }],
  'i-user': [{ c: [12, 8, 3.6] }, { d: 'M4.5 20a7.5 7.5 0 0 1 15 0' }],
};

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const IconSprite: React.FC = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
    <defs>
      {Object.entries(SYMBOLS).map(([id, shapes]) => (
        <symbol key={id} id={id} viewBox="0 0 24 24">
          {shapes.map((s, i) => {
            if ('d' in s) {
              return <path key={i} d={s.d} {...strokeProps} strokeWidth={s.w ?? 2} strokeDasharray={s.dash} />;
            }
            if ('c' in s) {
              return <circle key={i} cx={s.c[0]} cy={s.c[1]} r={s.c[2]} {...strokeProps} />;
            }
            if ('r' in s) {
              return <rect key={i} x={s.r[0]} y={s.r[1]} width={s.r[2]} height={s.r[3]} rx={s.r[4]} {...strokeProps} />;
            }
            return <circle key={i} cx={s.dot[0]} cy={s.dot[1]} r={1.2} fill="currentColor" />;
          })}
        </symbol>
      ))}
    </defs>
  </svg>
);

export const Icon: React.FC<{ name: string; size?: number }> = ({ name, size = 16 }) => (
  <svg width={size} height={size} aria-hidden="true" focusable="false">
    <use href={`#${name}`} />
  </svg>
);

